module.exports = __webpack_public_path__ + "static/img/service.18016f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service.png
// module id = 513
// module chunks = 1